import React from 'react';
import { Link } from 'react-router-dom';

const today = new Date();

const Footer = () => {
    return (
        <>
            <footer      style={{
          background: `url(assets/img/headerBg.png)`,
          backgroundPosition: "",
          backgroundSize: "cover",
          width:"100%",
          minHeight:"572px"
        }}>
                <div className="footer__area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="footer__widget">
                                    <div className="m-img mb-30">
                                        <Link to="/">
                                            <img src="assets/img/logo-dark.png" alt="Dsider" />
                                        </Link>
                                    </div>
                                    <p className='footer-text custom-layout'>Dsider democratizes planning by combining knowledge, economic insights, and efficient workflows, empowering users across all levels and organizations to make better, collaborative decisions that drive lasting value—from strategy to operations—with ease and precision.</p>
                                </div>
                                {/* <div className="mail">
                                        <a href="mailto:contactus@dsider.app">contactus@dsider.app</a>
                                        <Link to="/" className="social">
                                            <img src="assets/img/linkedin2.png" alt="Dsider" />
                                        </Link>
                                    </div> */}
                            </div>
                            <div className="col-xl-6">
                                <div className="footer__links">
                                    <ul>
                                        <li><Link to="/">Solutions</Link></li>
                                        <li><Link to="/why-dsider">Technology</Link></li>
                                        <li><Link to="/features">Products</Link></li>
                                        <li><Link to="/use-cases">Case Studies</Link></li>
                                       
                                    </ul>
                                </div>
                               
                            </div>
                        </div>
                        {/* <div className="row">
                            <div className="col-xl-12">
                                <div className="footer__copyright">
                                    <p>Dsider &copy; {today.getFullYear()} - All Rights Reserved.</p>
                                    <p>
                                        Developed by
                                        <a href="//sjain.io/" target="_blank" rel="noopener noreferrer">
                                            <img src="assets/img/sjain-logo.png" alt="" />
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </footer>
        </>
    );
};

export default Footer;